export default {
  items: [
    {
      name: "Inicio",
      url: "/dashboard",
      icon: "icon-grid",
    },
    {
      name: "Pruebas",
      url: "/tests",
      icon: "icon-puzzle",
    },
    {
      name: "Estudiantes",
      url: "/students",
      icon: "icon-pencil",
    },
    {
      name: "Maestros",
      url: "/teachers",
      icon: "icon-pencil",
    },
    {
      name: "Tarjetones",
      url: "/admin-tarjetones",
      icon: "icon-list",
    },
    {
      name: "Metas",
      url: "/goals-management",
      icon: "icon-list",
    },
    {
      name: "Usuarios",
      url: "/users",
      icon: "icon-user",
    },
    {
      name: "Notificaciones",
      url: "/notifications",
      icon: "icon-doc",
    },
    {
      name: "Archivados",
      url: "/archived",
      icon: "icon-user",
    },
  ],
};
